import request from '@/utils/request'
//测评详情页
export function measurement_details(data){
	return request({
    url: '/admin/Xplan/xplandetail',
    method: 'POST',
    data: data || {}
  })
}
//测评邀请他人评价页
export function gettitle(data){
	return request({
    url: '/admin/Xplan/gettitle',
    method: 'POST',
    data: data || {}
  })
}
//他人评价页
export function ability(data){
	return request({
    url: '/admin/Xplan/ability',
    method: 'POST',
    data: data || {}
  })
}
//提交他人评价页
export function abilitycommit(data){
	return request({
    url: '/admin/Xplan/abilitycommit',
    method: 'POST',
    data: data || {}
  })
}

//测评报告页
export function measurement_reprot(data){
	return request({
    url: '/admin/Xplan/reprot',
    method: 'POST',
    data: data || {}
  })
}
// 开始测评
export function measurement_index(data){
  return request({
    url: '/admin/Xplan/index',
    method: 'POST',
    data: data || {}
  })
}
// 提交测评数据
export function measurement_answer(data){
  return request({
    url: '/admin/Xplan/answer',
    method: 'POST',
    data: data || {}
  })
}
// 单独测试推送--获取数据
export function measurement_new_index(data){
  return request({
    url: '/admin/ceping49/index',
    method: 'POST',
    data: data || {}
  })
}
// 单独测试测试--自评--提交数据
export function measurement_new_answer(data){
  return request({
    url: '/admin/ceping49/answer',
    method: 'POST',
    data: data || {}
  })
}
// 单独测试测试  他评  提交数据
export function measurement_new_ta_answer(data){
  return request({
    url: '/admin/ceping49/ta_answer',
    method: 'POST',
    data: data || {}
  })
}
// 单独测试推送  他评  获取数据
export function measurement_new_ta_index(data){
  return request({
    url: '/admin/ceping49/ta_index',
    method: 'POST',
    data: data || {}
  })
}
// 新测试报告页接口
export function measurement_new_all_report(data){
  return request({
    url: '/admin/ceping49/report',
    method: 'POST',
    data: data || {}
  })
}
// 新测试报告页接口 --- 新增+1
export function measurement_new_all1_report(data){
  return request({
    url: '/admin/ceping52/report',
    method: 'POST',
    data: data || {}
  })
}
// 新测试报告页重置
export function measurement_new_all1_reset(data){
  return request({
    url: '/admin/ceping52/reset',
    method: 'POST',
    data: data || {}
  })
}
// 单独测试测试  他评  提交数据 --- 新增+1
export function measurement_new_ta1_answer(data){
  return request({
    url: '/admin/ceping52/ta_answer',
    method: 'POST',
    data: data || {}
  })
}
// 单独测试推送  他评  获取数据 --- 新增+1
export function measurement_new_ta1_index(data){
  return request({
    url: '/admin/ceping52/ta_index',
    method: 'POST',
    data: data || {}
  })
}
// 单独测试推送--获取数据 --- 新增+1
export function measurement_new1_index(data){
  return request({
    url: '/admin/ceping52/index',
    method: 'POST',
    data: data || {}
  })
}
// 单独测试测试--自评--提交数据 --- 新增+1
export function measurement_new1_answer(data){
  return request({
    url: '/admin/ceping52/answer',
    method: 'POST',
    data: data || {}
  })
}

// 自我分化
export function ceping47_report(data){
  return request({
    url: '/admin/ceping47/report',
    method: 'POST',
    data: data || {}
  })
}
// 自我分化答题
export function ceping47_index(data){
  return request({
    url: '/admin/ceping47/index',
    method: 'POST',
    data: data || {}
  })
}
// 自我分化---生成报告
export function ceping47_answer(data){
  return request({
    url: '/admin/ceping47/answer',
    method: 'POST',
    data: data || {}
  })
}
//霍兰德测评报告页
export function ceping51_report(data){
  return request({
    url: '/admin/ceping51/report',
    method: 'POST',
    data: data || {}
  })
}
//职业价值观测评报告页
export function worth_report(data){
  return request({
    url: '/admin/Worth/report',
    method: 'POST',
    data: data || {}
  })
}
// 职业价值观测评
export function worth_index(data){
  return request({
    url: '/admin/Worth/index',
    method: 'POST',
    data: data || {}
  })
}
// 职业价值观测评提交答案
export function worth_answer(data){
  return request({
    url: '/admin/Worth/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德测评
export function ceping51_index(data){
  return request({
    url: '/admin/ceping51/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德提交答案
export function ceping51_answer(data){
  return request({
    url: '/admin/ceping51/answer',
    method: 'POST',
    data: data || {}
  })
}

//从减肥看灵魂动物测评报告页
export function ceping54_report(data){
  return request({
    url: '/admin/ceping54/report',
    method: 'POST',
    data: data || {}
  })
}
// 从减肥看灵魂动物测评
export function ceping54_index(data){
  return request({
    url: '/admin/ceping54/index',
    method: 'POST',
    data: data || {}
  })
}
// 从减肥看灵魂动物提交答案
export function ceping54_answer(data){
  return request({
    url: '/admin/ceping54/answer',
    method: 'POST',
    data: data || {}
  })
}
// 从减肥看灵魂动物重新测试
export function ceping54_reset(data){
  return request({
    url: '/admin/ceping54/reset',
    method: 'POST',
    data: data || {}
  })
}
// 产品经理胜任能力测评
export function ceping56_index(data){
  return request({
    url: '/admin/ceping56/index',
    method: 'POST',
    data: data || {}
  })
}
// 产品经理胜任能力测评提交答案
export function ceping56_answer(data){
  return request({
    url: '/admin/ceping56/answer',
    method: 'POST',
    data: data || {}
  })
}
// 产品经理胜任能力测评重新测试
export function ceping56_reset(data){
  return request({
    url: '/admin/ceping56/reset',
    method: 'POST',
    data: data || {}
  })
}
// 产品经理胜任能力测评报告
export function ceping56_report(data){
  return request({
    url: '/admin/ceping56/report',
    method: 'POST',
    data: data || {}
  })
}
// 产品经理胜任能力自测
export function ceping57_index(data){
  return request({
    url: '/admin/ceping57/index',
    method: 'POST',
    data: data || {}
  })
}
// 产品经理胜任能力自测提交答案
export function ceping57_answer(data){
  return request({
    url: '/admin/ceping57/answer',
    method: 'POST',
    data: data || {}
  })
}
// 产品经理胜任能力自测重新测试
export function ceping57_reset(data){
  return request({
    url: '/admin/ceping57/reset',
    method: 'POST',
    data: data || {}
  })
}
// 产品经理胜任能力自测报告
export function ceping57_report(data){
  return request({
    url: '/admin/ceping57/report',
    method: 'POST',
    data: data || {}
  })
}

// 生涯信念测评详情
export function ceping55_detail(data){
  return request({
    url: '/admin/ceping55/detail',
    method: 'POST',
    data: data || {}
  })
}
// 生涯信念测评
export function ceping55_index(data){
  return request({
    url: '/admin/ceping55/index',
    method: 'POST',
    data: data || {}
  })
}
// 生涯信念测评提交答案
export function ceping55_answer(data){
  return request({
    url: '/admin/ceping55/answer',
    method: 'POST',
    data: data || {}
  })
}
// 生涯信念测评重新测试
export function ceping55_reset(data){
  return request({
    url: '/admin/ceping55/reset',
    method: 'POST',
    data: data || {}
  })
}
// 生涯信念测评报告
export function ceping55_report(data){
  return request({
    url: '/admin/ceping55/report',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评
export function ceping59_index(data){
  return request({
    url: '/admin/ceping59/index',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评提交答案
export function ceping59_answer(data){
  return request({
    url: '/admin/ceping59/answer',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评  他评  提交数据 --- 新增+1
export function ceping59_ta_answer(data){
  return request({
    url: '/admin/ceping59/ta_answer',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评  他评  获取数据 --- 新增+1
export function ceping59_ta_index(data){
  return request({
    url: '/admin/ceping59/ta_index',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评重新测试
export function ceping59_reset(data){
  return request({
    url: '/admin/ceping59/reset',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评报告
export function ceping59_report(data){
  return request({
    url: '/admin/ceping59/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德测评
export function ceping61_index(data){
  return request({
    url: '/admin/ceping61/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德测评提交答案
export function ceping61_answer(data){
  return request({
    url: '/admin/ceping61/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德测评重新测试
export function ceping61_reset(data){
  return request({
    url: '/admin/ceping61/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德测评报告
export function ceping61_report(data){
  return request({
    url: '/admin/ceping61/report',
    method: 'POST',
    data: data || {}
  })
}

// 工作家庭平衡状态测评详情
export function ceping62_detail(data){
  return request({
    url: '/admin/ceping62/detail',
    method: 'POST',
    data: data || {}
  })
}
// 工作家庭平衡状态测评
export function ceping62_index(data){
  return request({
    url: '/admin/ceping62/index',
    method: 'POST',
    data: data || {}
  })
}
// 工作家庭平衡状态测评提交答案
export function ceping62_answer(data){
  return request({
    url: '/admin/ceping62/answer',
    method: 'POST',
    data: data || {}
  })
}
// 工作家庭平衡状态测评重新测试
export function ceping62_reset(data){
  return request({
    url: '/admin/ceping62/reset',
    method: 'POST',
    data: data || {}
  })
}
// 工作家庭平衡状态测评报告
export function ceping62_report(data){
  return request({
    url: '/admin/ceping62/report',
    method: 'POST',
    data: data || {}
  })
}

// 测评列表
export function Evaluation_list(data){
  return request({
    url: '/api/Evaluation/list',
    method: 'POST',
    data: data || {}
  })
}

// 测评模板
export function evaluation_index(data){
  return request({
    url: '/api/evaluation/index',
    method: 'POST',
    data: data || {}
  })
}
// 测评模板提交答案
export function evaluation_answer(data){
  return request({
    url: '/api/evaluation/answer',
    method: 'POST',
    data: data || {}
  })
}

// 测评模板
export function ext_evaluation_index(data){
  return request({
    url: '/api/ext_evaluation/index',
    method: 'POST',
    data: data || {}
  })
}
// 测评模板提交答案
export function ext_evaluation_answer(data){
  return request({
    url: '/api/ext_evaluation/answer',
    method: 'POST',
    data: data || {}
  })
}
// 测评模板报告
export function ext_evaluation_report(data){
  return request({
    url: '/api/ext_evaluation/report',
    method: 'POST',
    data: data || {}
  })
}

// 测评模板重新测试
export function evaluation_reset(data){
  return request({
    url: '/api/evaluation/reset',
    method: 'POST',
    data: data || {}
  })
}
// 测评模板报告
export function evaluation_report(data){
  return request({
    url: '/api/evaluation/report',
    method: 'POST',
    data: data || {}
  })
}
// 职业价值观测评
export function ceping63_index(data){
  return request({
    url: '/admin/ceping63/index',
    method: 'POST',
    data: data || {}
  })
}
// 职业价值观测评提交答案
export function ceping63_answer(data){
  return request({
    url: '/admin/ceping63/answer',
    method: 'POST',
    data: data || {}
  })
}
// 职业价值观测评重新测试
export function ceping63_reset(data){
  return request({
    url: '/admin/ceping63/reset',
    method: 'POST',
    data: data || {}
  })
}
// 职业价值观测评报告
export function ceping63_report(data){
  return request({
    url: '/admin/ceping63/report',
    method: 'POST',
    data: data || {}
  })
}

// 价值观测评
export function ceping64_index(data){
  return request({
    url: '/admin/ceping64/index',
    method: 'POST',
    data: data || {}
  })
}
// 价值观测评提交答案
export function ceping64_answer(data){
  return request({
    url: '/admin/ceping64/answer',
    method: 'POST',
    data: data || {}
  })
}
// 价值观测评重新测试
export function ceping64_reset(data){
  return request({
    url: '/admin/ceping64/reset',
    method: 'POST',
    data: data || {}
  })
}
// 价值观测评报告
export function ceping64_report(data){
  return request({
    url: '/admin/ceping64/report',
    method: 'POST',
    data: data || {}
  })
}

// 价值观测评
export function ceping110_index(data){
  return request({
    url: '/admin/ceping110/index',
    method: 'POST',
    data: data || {}
  })
}
// 价值观测评提交答案
export function ceping110_answer(data){
  return request({
    url: '/admin/ceping110/answer',
    method: 'POST',
    data: data || {}
  })
}
// 价值观测评重新测试
export function ceping110_reset(data){
  return request({
    url: '/admin/ceping110/reset',
    method: 'POST',
    data: data || {}
  })
}
// 价值观测评报告
export function ceping110_report(data){
  return request({
    url: '/admin/ceping110/report',
    method: 'POST',
    data: data || {}
  })
}

// 价值观测评 发送邮箱
export function sendPdf(data){
  return request({
    url: '/api/pdfbuild/sendPdf',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评
export function ceping65_index(data){
  return request({
    url: '/admin/ceping65/index',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评提交答案
export function ceping65_answer(data){
  return request({
    url: '/admin/ceping65/answer',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评  他评  提交数据 --- 新增+1
export function ceping65_ta_answer(data){
  return request({
    url: '/admin/ceping65/ta_answer',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评  他评  获取数据 --- 新增+1
export function ceping65_ta_index(data){
  return request({
    url: '/admin/ceping65/ta_index',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评重新测试
export function ceping65_reset(data){
  return request({
    url: '/admin/ceping65/reset',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评报告
export function ceping65_report(data){
  return request({
    url: '/admin/ceping65/report',
    method: 'POST',
    data: data || {}
  })
}

// 能力热力图测评
export function ceping112_index(data){
  return request({
    url: '/admin/ceping112/index',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评提交答案
export function ceping112_answer(data){
  return request({
    url: '/admin/ceping112/answer',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评  他评  提交数据 --- 新增+1
export function ceping112_ta_answer(data){
  return request({
    url: '/admin/ceping112/ta_answer',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评  他评  获取数据 --- 新增+1
export function ceping112_ta_index(data){
  return request({
    url: '/admin/ceping112/ta_index',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评重新测试
export function ceping112_reset(data){
  return request({
    url: '/admin/ceping112/reset',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评报告
export function ceping112_report(data){
  return request({
    url: '/admin/ceping112/report',
    method: 'POST',
    data: data || {}
  })
}
// 职业定向2.0测评
export function ceping67_index(data){
  return request({
    url: '/admin/ceping67/index',
    method: 'POST',
    data: data || {}
  })
}

// 职业定向2.0测评---分段答题
export function ceping67_section(data){
  return request({
    url: '/admin/ceping67/section',
    method: 'POST',
    data: data || {}
  })
}
// 职业定向2.0测评提交答案
export function ceping67_answer(data){
  return request({
    url: '/admin/ceping67/answer',
    method: 'POST',
    data: data || {}
  })
}
// 职业定向2.0测评重新测试
export function ceping67_reset(data){
  return request({
    url: '/admin/ceping67/reset',
    method: 'POST',
    data: data || {}
  })
}
// 职业定向2.0测评报告
export function ceping67_report(data){
  return request({
    url: '/admin/ceping67/report',
    method: 'POST',
    data: data || {}
  })
}

// 职业定向2.0测评
export function ceping111_index(data){
  return request({
    url: '/admin/ceping111/index',
    method: 'POST',
    data: data || {}
  })
}

// 职业定向2.0测评---分段答题
export function ceping111_section(data){
  return request({
    url: '/admin/ceping111/section',
    method: 'POST',
    data: data || {}
  })
}
// 职业定向2.0测评提交答案
export function ceping111_answer(data){
  return request({
    url: '/admin/ceping111/answer',
    method: 'POST',
    data: data || {}
  })
}
// 职业定向2.0测评重新测试
export function ceping111_reset(data){
  return request({
    url: '/admin/ceping111/reset',
    method: 'POST',
    data: data || {}
  })
}
// 职业定向2.0测评报告
export function ceping111_report(data){
  return request({
    url: '/admin/ceping111/report',
    method: 'POST',
    data: data || {}
  })
}

// 测评报错反馈
export function debug(data){
  return request({
    url: '/api/debug/report',
    method: 'POST',
    data: data || {}
  })
}

// （ceping67）获取测评进度
export function getData(data){
  return request({
    url: '/admin/ceping/getData',
    method: 'POST',
    data: data || {}
  })
}

// （ceping67）保存测评进度
export function saveData(data){
  return request({
    url: '/admin/ceping/saveData',
    method: 'POST',
    data: data || {}
  })
}

// 能力探索卡片获取数据
export function ceping68_index(data){
  return request({
    url: '/admin/ceping68/index',
    method: 'POST',
    data: data || {}
  })
}

// 能力探索卡片-提交答案
export function ceping68_answer(data){
  return request({
    url: '/admin/ceping68/answer',
    method: 'POST',
    data: data || {}
  })
}

// 能力探索卡片-获取报告
export function ceping68_report(data){
  return request({
    url: '/admin/ceping68/report',
    method: 'POST',
    data: data || {}
  })
}

// 能力探索卡片-重测
export function ceping68_reset(data){
  return request({
    url: '/admin/ceping68/reset',
    method: 'POST',
    data: data || {}
  })
}

// 选对
// 选对测评
export function xuandui65_index(data){
  return request({
    url: '/admin/xuandui65/index',
    method: 'POST',
    data: data || {}
  })
}
// 选对测评提交答案
export function xuandui65_answer(data){
  return request({
    url: '/admin/xuandui65/answer',
    method: 'POST',
    data: data || {}
  })
}
// 选对测评  他评  提交数据 --- 新增+1
export function xuandui65_ta_answer(data){
  return request({
    url: '/admin/xuandui65/ta_answer',
    method: 'POST',
    data: data || {}
  })
}
// 选对测评  他评  获取数据 --- 新增+1
export function xuandui65_ta_index(data){
  return request({
    url: '/admin/xuandui65/ta_index',
    method: 'POST',
    data: data || {}
  })
}
// 选对测评重新测试
export function xuandui65_reset(data){
  return request({
    url: '/admin/xuandui65/reset',
    method: 'POST',
    data: data || {}
  })
}
// 选对测评报告
export function xuandui65_report(data){
  return request({
    url: '/admin/xuandui65/report',
    method: 'POST',
    data: data || {}
  })
}

// 能力热力图测评
export function test65_index(data){
  return request({
    url: '/admin/test65/index',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评提交答案
export function test65_answer(data){
  return request({
    url: '/admin/test65/answer',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评  他评  提交数据 --- 新增+1
export function test65_ta_answer(data){
  return request({
    url: '/admin/test65/ta_answer',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评  他评  获取数据 --- 新增+1
export function test65_ta_index(data){
  return request({
    url: '/admin/test65/ta_index',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评重新测试
export function test65_reset(data){
  return request({
    url: '/admin/test65/reset',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评报告
export function test65_report(data){
  return request({
    url: '/admin/test65/report',
    method: 'POST',
    data: data || {}
  })
}


// ACCA
// ACCA测评
export function acca65_index(data){
  return request({
    url: '/admin/acca65/index',
    method: 'POST',
    data: data || {}
  })
}
// ACCA测评提交答案
export function acca65_answer(data){
  return request({
    url: '/admin/acca65/answer',
    method: 'POST',
    data: data || {}
  })
}
// ACCA测评  他评  提交数据 --- 新增+1
export function acca65_ta_answer(data){
  return request({
    url: '/admin/acca65/ta_answer',
    method: 'POST',
    data: data || {}
  })
}
// ACCA测评  他评  获取数据 --- 新增+1
export function acca65_ta_index(data){
  return request({
    url: '/admin/acca65/ta_index',
    method: 'POST',
    data: data || {}
  })
}
// ACCA测评重新测试
export function acca65_reset(data){
  return request({
    url: '/admin/acca65/reset',
    method: 'POST',
    data: data || {}
  })
}
// ACCA测评报告
export function acca65_report(data){
  return request({
    url: '/admin/acca65/report',
    method: 'POST',
    data: data || {}
  })
}

// ACCA测评提交信息
export function save_info(data){
  return request({
    url: '/admin/acca65/save_info',
    method: 'POST',
    data: data || {}
  })
}

// ACCA测评获取信息
export function get_info(data){
  return request({
    url: '/admin/acca65/get_info',
    method: 'POST',
    data: data || {}
  })
}


// ====================大学生兴趣测评===========
// 大学生兴趣
// 大学生兴趣测评
export function ceping69_index(data){
  return request({
    url: '/admin/ceping69/index',
    method: 'POST',
    data: data || {}
  })
}
// 大学生兴趣测评提交答案
export function ceping69_answer(data){
  return request({
    url: '/admin/ceping69/answer',
    method: 'POST',
    data: data || {}
  })
}
// 大学生兴趣测评  他评  提交数据 --- 新增+1
export function ceping69_ta_answer(data){
  return request({
    url: '/admin/ceping69/ta_answer',
    method: 'POST',
    data: data || {}
  })
}
// 大学生兴趣测评  他评  获取数据 --- 新增+1
export function ceping69_ta_index(data){
  return request({
    url: '/admin/ceping69/ta_index',
    method: 'POST',
    data: data || {}
  })
}
// 大学生兴趣测评重新测试
export function ceping69_reset(data){
  return request({
    url: '/admin/ceping69/reset',
    method: 'POST',
    data: data || {}
  })
}
// 大学生兴趣测评报告
export function ceping69_report(data){
  return request({
    url: '/admin/ceping69/report',
    method: 'POST',
    data: data || {}
  })
}

// ==========馒头版测评===========
// 馒头版测评
export function ceping70_index(data){
  return request({
    url: '/admin/ceping70/index',
    method: 'POST',
    data: data || {}
  })
}
// 馒头版测评提交答案
export function ceping70_answer(data){
  return request({
    url: '/admin/ceping70/answer',
    method: 'POST',
    data: data || {}
  })
}
// 馒头版测评  他评  提交数据 --- 新增+1
export function ceping70_ta_answer(data){
  return request({
    url: '/admin/ceping70/ta_answer',
    method: 'POST',
    data: data || {}
  })
}
// 馒头版测评  他评  获取数据 --- 新增+1
export function ceping70_ta_index(data){
  return request({
    url: '/admin/ceping70/ta_index',
    method: 'POST',
    data: data || {}
  })
}
// 馒头版测评重新测试
export function ceping70_reset(data){
  return request({
    url: '/admin/ceping70/reset',
    method: 'POST',
    data: data || {}
  })
}
// 馒头版测评报告
export function ceping70_report(data){
  return request({
    url: '/admin/ceping70/report',
    method: 'POST',
    data: data || {}
  })
}
// 馒头版测评详情
export function ceping70_detail(data){
  return request({
    url: '/admin/ceping70/detail',
    method: 'POST',
    data: data || {}
  })
}

/**
 * ================复制测评64、65、67
 * 2020年7月14日 11点03分
 */


// 价值观测评
export function bd_ceping64_index(data){
  return request({
    url: '/admin/bd_ceping64/index',
    method: 'POST',
    data: data || {}
  })
}
// 价值观测评提交答案
export function bd_ceping64_answer(data){
  return request({
    url: '/admin/bd_ceping64/answer',
    method: 'POST',
    data: data || {}
  })
}
// 价值观测评重新测试
export function bd_ceping64_reset(data){
  return request({
    url: '/admin/bd_ceping64/reset',
    method: 'POST',
    data: data || {}
  })
}
// 价值观测评报告
export function bd_ceping64_report(data){
  return request({
    url: '/admin/bd_ceping64/report',
    method: 'POST',
    data: data || {}
  })
}


// 能力热力图测评
export function bd_ceping65_index(data){
  return request({
    url: '/admin/bd_ceping65/index',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评提交答案
export function bd_ceping65_answer(data){
  return request({
    url: '/admin/bd_ceping65/answer',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评  他评  提交数据 --- 新增+1
export function bd_ceping65_ta_answer(data){
  return request({
    url: '/admin/bd_ceping65/ta_answer',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评  他评  获取数据 --- 新增+1
export function bd_ceping65_ta_index(data){
  return request({
    url: '/admin/bd_ceping65/ta_index',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评重新测试
export function bd_ceping65_reset(data){
  return request({
    url: '/admin/bd_ceping65/reset',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评报告
export function bd_ceping65_report(data){
  return request({
    url: '/admin/bd_ceping65/report',
    method: 'POST',
    data: data || {}
  })
}

// 职业定向2.0测评
export function bd_ceping67_index(data){
  return request({
    url: '/admin/bd_ceping67/index',
    method: 'POST',
    data: data || {}
  })
}

// 职业定向2.0测评---分段答题
export function bd_ceping67_section(data){
  return request({
    url: '/admin/bd_ceping67/section',
    method: 'POST',
    data: data || {}
  })
}
// 职业定向2.0测评提交答案
export function bd_ceping67_answer(data){
  return request({
    url: '/admin/bd_ceping67/answer',
    method: 'POST',
    data: data || {}
  })
}
// 职业定向2.0测评重新测试
export function bd_ceping67_reset(data){
  return request({
    url: '/admin/bd_ceping67/reset',
    method: 'POST',
    data: data || {}
  })
}
// 职业定向2.0测评报告
export function bd_ceping67_report(data){
  return request({
    url: '/admin/bd_ceping67/report',
    method: 'POST',
    data: data || {}
  })
}



// ==========X计划复制测评===========
// X计划测评
export function ceping71_index(data){
  return request({
    url: '/admin/ceping71/index',
    method: 'POST',
    data: data || {}
  })
}
// X计划测评提交答案
export function ceping71_answer(data){
  return request({
    url: '/admin/ceping71/answer',
    method: 'POST',
    data: data || {}
  })
}

// X计划测评重新测试
export function ceping71_reset(data){
  return request({
    url: '/admin/ceping71/reset',
    method: 'POST',
    data: data || {}
  })
}
// X计划测评报告
export function ceping71_report(data){
  return request({
    url: '/admin/ceping71/report',
    method: 'POST',
    data: data || {}
  })
}
// X计划测评详情
export function ceping71_detail(data){
  return request({
    url: '/admin/ceping71/detail',
    method: 'POST',
    data: data || {}
  })
}

// ==========X计划复制测评===========
// X计划测评
export function ceping105_index(data){
  return request({
    url: '/admin/ceping105/index',
    method: 'POST',
    data: data || {}
  })
}
// X计划测评提交答案
export function ceping105_answer(data){
  return request({
    url: '/admin/ceping105/answer',
    method: 'POST',
    data: data || {}
  })
}

// X计划测评重新测试
export function ceping105_reset(data){
  return request({
    url: '/admin/ceping105/reset',
    method: 'POST',
    data: data || {}
  })
}
// X计划测评报告
export function ceping105_report(data){
  return request({
    url: '/admin/ceping105/report',
    method: 'POST',
    data: data || {}
  })
}
// X计划测评详情
export function ceping105_detail(data){
  return request({
    url: '/admin/ceping105/detail',
    method: 'POST',
    data: data || {}
  })
}

export function ceping96_index(data){
  return request({
    url: '/admin/ceping96/index',
    method: 'POST',
    data: data || {}
  })
}
// X计划测评提交答案
export function ceping96_answer(data){
  return request({
    url: '/admin/ceping96/answer',
    method: 'POST',
    data: data || {}
  })
}

// X计划测评重新测试
export function ceping96_reset(data){
  return request({
    url: '/admin/ceping96/reset',
    method: 'POST',
    data: data || {}
  })
}
// X计划测评报告
export function ceping96_report(data){
  return request({
    url: '/admin/ceping96/report',
    method: 'POST',
    data: data || {}
  })
}
// X计划测评详情
export function ceping96_detail(data){
  return request({
    url: '/admin/ceping96/detail',
    method: 'POST',
    data: data || {}
  })
}

// 生涯定位测评
export function ceping72_index(data){
  return request({
    url: '/admin/ceping72/index',
    method: 'POST',
    data: data || {}
  })
}
// 生涯定位测评提交答案
export function ceping72_answer(data){
  return request({
    url: '/admin/ceping72/answer',
    method: 'POST',
    data: data || {}
  })
}
// 生涯定位测评重新测试
export function ceping72_reset(data){
  return request({
    url: '/admin/ceping72/reset',
    method: 'POST',
    data: data || {}
  })
}
// 生涯定位测评报告
export function ceping72_report(data){
  return request({
    url: '/admin/ceping72/report',
    method: 'POST',
    data: data || {}
  })
}
// 生涯定位测评保存兴趣
export function ceping72_save_extra(data){
  return request({
    url: '/admin/ceping72/save_extra',
    method: 'POST',
    data: data || {}
  })
}

// 生涯定位测评保存兴趣--来源渠道
export function source(data){
  return request({
    url: '/admin/ceping/source',
    method: 'POST',
    data: data || {}
  })
}

// 生涯定位测评保存兴趣--获取分享报告
export function evaluation(data){
  return request({
    url: '/admin/ceping72/evaluation',
    method: 'POST',
    data: data || {}
  })
}

// ==========测评广告===========
// 测评广告查询
export function ad(data){
  return request({
    url: '/admin/ceping/ad',
    method: 'POST',
    data: data || {}
  })
}

// 测评额外信息查询
export function get_extra_info(data){
  return request({
    url: '/admin/ceping/get_extra_info',
    method: 'POST',
    data: data || {}
  })
}



// 霍兰德职业倾向测评
export function ceping73_index(data){
  return request({
    url: '/admin/ceping73/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping73_answer(data){
  return request({
    url: '/admin/ceping73/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping73_reset(data){
  return request({
    url: '/admin/ceping73/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping73_report(data){
  return request({
    url: '/admin/ceping73/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping73_save_extra(data){
  return request({
    url: '/admin/ceping73/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping73_detail(data){
  return request({
    url: '/admin/ceping73/detail',
    method: 'POST',
    data: data || {}
  })
}




// 霍兰德职业倾向测评
export function ceping98_index(data){
  return request({
    url: '/admin/ceping98/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping98_answer(data){
  return request({
    url: '/admin/ceping98/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping98_reset(data){
  return request({
    url: '/admin/ceping98/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping98_report(data){
  return request({
    url: '/admin/ceping98/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping98_save_extra(data){
  return request({
    url: '/admin/ceping98/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping98_detail(data){
  return request({
    url: '/admin/ceping98/detail',
    method: 'POST',
    data: data || {}
  })
}




// 霍兰德职业倾向测评
export function ceping99_index(data){
  return request({
    url: '/admin/ceping99/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping99_answer(data){
  return request({
    url: '/admin/ceping99/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping99_reset(data){
  return request({
    url: '/admin/ceping99/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping99_report(data){
  return request({
    url: '/admin/ceping99/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping99_save_extra(data){
  return request({
    url: '/admin/ceping99/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping99_detail(data){
  return request({
    url: '/admin/ceping99/detail',
    method: 'POST',
    data: data || {}
  })
}





// 原生家庭详情
export function ceping47_detail(data){
  return request({
    url: '/admin/ceping47/detail',
    method: 'POST',
    data: data || {}
  })
}

// 可迁移能力（自评）
export function ceping49_detail(data){
  return request({
    url: '/admin/ceping49/detail',
    method: 'POST',
    data: data || {}
  })
}

// 可迁移能力（他评）
export function ceping52_detail(data){
  return request({
    url: '/admin/ceping52/detail',
    method: 'POST',
    data: data || {}
  })
}

// 野兽瘦身测评详情
export function ceping54_detail(data){
  return request({
    url: '/admin/ceping54/detail',
    method: 'POST',
    data: data || {}
  })
}

/**
 *
 *新野兽减肥测评
 * @export
 * @param {*} data
 * @returns
 */

//从减肥看灵魂动物测评报告页
export function ceping74_report(data){
  return request({
    url: '/admin/ceping74/report',
    method: 'POST',
    data: data || {}
  })
}
// 从减肥看灵魂动物测评
export function ceping74_index(data){
  return request({
    url: '/admin/ceping74/index',
    method: 'POST',
    data: data || {}
  })
}
// 从减肥看灵魂动物提交答案
export function ceping74_answer(data){
  return request({
    url: '/admin/ceping74/answer',
    method: 'POST',
    data: data || {}
  })
}
// 从减肥看灵魂动物重新测试
export function ceping74_reset(data){
  return request({
    url: '/admin/ceping74/reset',
    method: 'POST',
    data: data || {}
  })
}

// 野兽瘦身测评详情
export function ceping74_detail(data){
  return request({
    url: '/admin/ceping74/detail',
    method: 'POST',
    data: data || {}
  })
}


/**
 *新馒头测评
 *
 * @export
 * @param {*} data
 * @returns
 */
export function ceping75_index(data){
  return request({
    url: '/admin/ceping75/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德测评提交答案
export function ceping75_answer(data){
  return request({
    url: '/admin/ceping75/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德测评重新测试
export function ceping75_reset(data){
  return request({
    url: '/admin/ceping75/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德测评报告
export function ceping75_report(data){
  return request({
    url: '/admin/ceping75/report',
    method: 'POST',
    data: data || {}
  })
}

// ====================复制大学生兴趣测评===========
// 大学生兴趣
// 大学生兴趣测评
export function bd_ceping69_index(data){
  return request({
    url: '/admin/bd_ceping69/index',
    method: 'POST',
    data: data || {}
  })
}
// 大学生兴趣测评提交答案
export function bd_ceping69_answer(data){
  return request({
    url: '/admin/bd_ceping69/answer',
    method: 'POST',
    data: data || {}
  })
}

// 大学生兴趣测评重新测试
export function bd_ceping69_reset(data){
  return request({
    url: '/admin/bd_ceping69/reset',
    method: 'POST',
    data: data || {}
  })
}
// 大学生兴趣测评报告
export function bd_ceping69_report(data){
  return request({
    url: '/admin/bd_ceping69/report',
    method: 'POST',
    data: data || {}
  })
}

// 可迁移能力报告（学生版）
export function ceping76_report(data){
  return request({
    url: '/admin/ceping76/report',
    method: 'POST',
    data: data || {}
  })
}
// 可迁移能力（学生版）重置
export function ceping76_reset(data){
  return request({
    url: '/admin/ceping76/reset',
    method: 'POST',
    data: data || {}
  })
}
// 可迁移能力（学生版） 他评  提交数据 
export function ceping76_ta_answer(data){
  return request({
    url: '/admin/ceping76/ta_answer',
    method: 'POST',
    data: data || {}
  })
}
// 可迁移能力（学生版）  他评  获取数据 
export function ceping76_ta_index(data){
  return request({
    url: '/admin/ceping76/ta_index',
    method: 'POST',
    data: data || {}
  })
}
// 可迁移能力（学生版）--获取数据
export function ceping76_index(data){
  return request({
    url: '/admin/ceping76/index',
    method: 'POST',
    data: data || {}
  })
}
// 可迁移能力（学生版）-自评--提交数据
export function ceping76_answer(data){
  return request({
    url: '/admin/ceping76/answer',
    method: 'POST',
    data: data || {}
  })
}

// 可迁移能力（学生版）-发送他评寄语
export function ceping76_ta_send_word(data){
  return request({
    url: '/admin/ceping76/ta_send_word',
    method: 'POST',
    data: data || {}
  })
}

// 可迁移能力（学生版）-获取他评寄语
export function ceping76_get_ta_word(data){
  return request({
    url: '/admin/ceping76/get_ta_word',
    method: 'POST',
    data: data || {}
  })
}

// 可迁移能力（学生版）
export function ceping76_detail(data){
  return request({
    url: '/admin/ceping76/detail',
    method: 'POST',
    data: data || {}
  })
}

// 测评44收集信息接口-获取收集信息
export function ceping44_extra(data){
  return request({
    url: '/admin/ceping44/extra',
    method: 'POST',
    data: data || {}
  })
}


// 测评44收集信息接口-提交收集信息
export function ceping44_save_extra(data){
  return request({
    url: '/admin/ceping44/save_extra',
    method: 'POST',
    data: data || {}
  })
}

// 推广复制ceping71-题目
export function sale_ceping71_index(data){
  return request({
    url: '/admin/sale_ceping71/index',
    method: 'POST',
    data: data || {}
  })
}
// 推广复制ceping71-答题
export function sale_ceping71_answer(data){
  return request({
    url: '/admin/sale_ceping71/answer',
    method: 'POST',
    data: data || {}
  })
}
// 推广复制ceping71-报告
export function sale_ceping71_report(data){
  return request({
    url: '/admin/sale_ceping71/report',
    method: 'POST',
    data: data || {}
  })
}

// 推广复制ceping105-题目
export function sale_ceping105_index(data){
  return request({
    url: '/admin/sale_ceping105/index',
    method: 'POST',
    data: data || {}
  })
}
// 推广复制ceping105-答题
export function sale_ceping105_answer(data){
  return request({
    url: '/admin/sale_ceping105/answer',
    method: 'POST',
    data: data || {}
  })
}
// 推广复制ceping105-报告
export function sale_ceping105_report(data){
  return request({
    url: '/admin/sale_ceping105/report',
    method: 'POST',
    data: data || {}
  })
}

/**
 *纯净版测评
 *
 * @export
 * @param {*} data
 * @returns
 */
export function test71_index(data){
  return request({
    url: '/admin/test71/index',
    method: 'POST',
    data: data || {}
  })
}
// 推广复制ceping71-答题
export function test71_answer(data){
  return request({
    url: '/admin/test71/answer',
    method: 'POST',
    data: data || {}
  })
}
// 推广复制ceping71-报告
export function test71_report(data){
  return request({
    url: '/admin/test71/report',
    method: 'POST',
    data: data || {}
  })
}

// 新测试报告页接口 --- 新增+1
export function test52_report(data){
  return request({
    url: '/admin/test52/report',
    method: 'POST',
    data: data || {}
  })
}
// 新测试报告页重置
export function test52_reset(data){
  return request({
    url: '/admin/test52/reset',
    method: 'POST',
    data: data || {}
  })
}
// 单独测试测试  他评  提交数据 --- 新增+1
export function test52_ta_answer(data){
  return request({
    url: '/admin/test52/ta_answer',
    method: 'POST',
    data: data || {}
  })
}
// 单独测试推送  他评  获取数据 --- 新增+1
export function test52_ta_index(data){
  return request({
    url: '/admin/test52/ta_index',
    method: 'POST',
    data: data || {}
  })
}
// 单独测试推送--获取数据 --- 新增+1
export function test52_index(data){
  return request({
    url: '/admin/test52/index',
    method: 'POST',
    data: data || {}
  })
}
// 单独测试测试--自评--提交数据 --- 新增+1
export function test52_answer(data){
  return request({
    url: '/admin/test52/answer',
    method: 'POST',
    data: data || {}
  })
}

// 可迁移能力详情
export function test52_detail(data){
  return request({
    url: '/admin/test52/detail',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德职业倾向测评
export function test73_index(data){
  return request({
    url: '/admin/test73/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function test73_answer(data){
  return request({
    url: '/admin/test73/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function test73_reset(data){
  return request({
    url: '/admin/test73/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function test73_report(data){
  return request({
    url: '/admin/test73/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function test73_save_extra(data){
  return request({
    url: '/admin/test73/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function test73_detail(data){
  return request({
    url: '/admin/test73/detail',
    method: 'POST',
    data: data || {}
  })
}

// 纯净版===end

/**
 * 新航道
 * @param {*} data 
 */
// 霍兰德职业倾向测评
export function ceping78_index(data){
  return request({
    url: '/admin/ceping78/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping78_answer(data){
  return request({
    url: '/admin/ceping78/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping78_reset(data){
  return request({
    url: '/admin/ceping78/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping78_report(data){
  return request({
    url: '/admin/ceping78/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping78_save_extra(data){
  return request({
    url: '/admin/ceping78/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping78_detail(data){
  return request({
    url: '/admin/ceping78/detail',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德职业倾向测评
export function ceping84_index(data){
  return request({
    url: '/admin/ceping84/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping84_answer(data){
  return request({
    url: '/admin/ceping84/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping84_reset(data){
  return request({
    url: '/admin/ceping84/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping84_report(data){
  return request({
    url: '/admin/ceping84/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping84_save_extra(data){
  return request({
    url: '/admin/ceping84/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping84_detail(data){
  return request({
    url: '/admin/ceping84/detail',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德职业倾向测评
export function ceping97_index(data){
  return request({
    url: '/admin/ceping97/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping97_answer(data){
  return request({
    url: '/admin/ceping97/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping97_reset(data){
  return request({
    url: '/admin/ceping97/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping97_report(data){
  return request({
    url: '/admin/ceping97/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping97_save_extra(data){
  return request({
    url: '/admin/ceping97/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping97_detail(data){
  return request({
    url: '/admin/ceping97/detail',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德职业倾向测评
export function ceping85_index(data){
  return request({
    url: '/admin/ceping85/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping85_answer(data){
  return request({
    url: '/admin/ceping85/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping85_reset(data){
  return request({
    url: '/admin/ceping85/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping85_report(data){
  return request({
    url: '/admin/ceping85/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping85_save_extra(data){
  return request({
    url: '/admin/ceping85/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping85_detail(data){
  return request({
    url: '/admin/ceping85/detail',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德职业倾向测评
export function ceping86_index(data){
  return request({
    url: '/admin/ceping86/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping86_answer(data){
  return request({
    url: '/admin/ceping86/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping86_reset(data){
  return request({
    url: '/admin/ceping86/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping86_report(data){
  return request({
    url: '/admin/ceping86/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping86_save_extra(data){
  return request({
    url: '/admin/ceping86/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping86_detail(data){
  return request({
    url: '/admin/ceping86/detail',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德职业倾向测评
export function ceping106_index(data){
  return request({
    url: '/admin/ceping106/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping106_answer(data){
  return request({
    url: '/admin/ceping106/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping106_reset(data){
  return request({
    url: '/admin/ceping106/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping106_report(data){
  return request({
    url: '/admin/ceping106/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping106_save_extra(data){
  return request({
    url: '/admin/ceping106/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping106_detail(data){
  return request({
    url: '/admin/ceping106/detail',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德职业倾向测评
export function ceping107_index(data){
  return request({
    url: '/admin/ceping107/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping107_answer(data){
  return request({
    url: '/admin/ceping107/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping107_reset(data){
  return request({
    url: '/admin/ceping107/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping107_report(data){
  return request({
    url: '/admin/ceping107/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping107_save_extra(data){
  return request({
    url: '/admin/ceping107/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping107_detail(data){
  return request({
    url: '/admin/ceping107/detail',
    method: 'POST',
    data: data || {}
  })
}


// 霍兰德职业倾向测评
export function ceping108_index(data){
  return request({
    url: '/admin/ceping108/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping108_answer(data){
  return request({
    url: '/admin/ceping108/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping108_reset(data){
  return request({
    url: '/admin/ceping108/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping108_report(data){
  return request({
    url: '/admin/ceping108/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping108_save_extra(data){
  return request({
    url: '/admin/ceping108/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping108_detail(data){
  return request({
    url: '/admin/ceping108/detail',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德职业倾向测评
export function ceping109_index(data){
  return request({
    url: '/admin/ceping109/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping109_answer(data){
  return request({
    url: '/admin/ceping109/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping109_reset(data){
  return request({
    url: '/admin/ceping109/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping109_report(data){
  return request({
    url: '/admin/ceping109/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping109_save_extra(data){
  return request({
    url: '/admin/ceping109/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping109_detail(data){
  return request({
    url: '/admin/ceping109/detail',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德职业倾向测评
export function ceping87_index(data){
  return request({
    url: '/admin/ceping87/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping87_answer(data){
  return request({
    url: '/admin/ceping87/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping87_reset(data){
  return request({
    url: '/admin/ceping87/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping87_report(data){
  return request({
    url: '/admin/ceping87/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping87_save_extra(data){
  return request({
    url: '/admin/ceping87/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping87_detail(data){
  return request({
    url: '/admin/ceping87/detail',
    method: 'POST',
    data: data || {}
  })
}


// 霍兰德职业倾向测评
export function ceping88_index(data){
  return request({
    url: '/admin/ceping88/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping88_answer(data){
  return request({
    url: '/admin/ceping88/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping88_reset(data){
  return request({
    url: '/admin/ceping88/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping88_report(data){
  return request({
    url: '/admin/ceping88/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping88_save_extra(data){
  return request({
    url: '/admin/ceping88/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping88_detail(data){
  return request({
    url: '/admin/ceping88/detail',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德职业倾向测评
export function ceping89_index(data){
  return request({
    url: '/admin/ceping89/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping89_answer(data){
  return request({
    url: '/admin/ceping89/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping89_reset(data){
  return request({
    url: '/admin/ceping89/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping89_report(data){
  return request({
    url: '/admin/ceping89/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping89_save_extra(data){
  return request({
    url: '/admin/ceping89/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping89_detail(data){
  return request({
    url: '/admin/ceping89/detail',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德职业倾向测评
export function ceping90_index(data){
  return request({
    url: '/admin/ceping90/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping90_answer(data){
  return request({
    url: '/admin/ceping90/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping90_reset(data){
  return request({
    url: '/admin/ceping90/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping90_report(data){
  return request({
    url: '/admin/ceping90/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping90_save_extra(data){
  return request({
    url: '/admin/ceping90/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping90_detail(data){
  return request({
    url: '/admin/ceping90/detail',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德职业倾向测评
export function ceping91_index(data){
  return request({
    url: '/admin/ceping91/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping91_answer(data){
  return request({
    url: '/admin/ceping91/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping91_reset(data){
  return request({
    url: '/admin/ceping91/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping91_report(data){
  return request({
    url: '/admin/ceping91/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping91_save_extra(data){
  return request({
    url: '/admin/ceping91/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping91_detail(data){
  return request({
    url: '/admin/ceping91/detail',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德职业倾向测评
export function ceping92_index(data){
  return request({
    url: '/admin/ceping92/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping92_answer(data){
  return request({
    url: '/admin/ceping92/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping92_reset(data){
  return request({
    url: '/admin/ceping92/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping92_report(data){
  return request({
    url: '/admin/ceping92/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping92_save_extra(data){
  return request({
    url: '/admin/ceping92/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping92_detail(data){
  return request({
    url: '/admin/ceping92/detail',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德职业倾向测评
export function ceping93_index(data){
  return request({
    url: '/admin/ceping93/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping93_answer(data){
  return request({
    url: '/admin/ceping93/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping93_reset(data){
  return request({
    url: '/admin/ceping93/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping93_report(data){
  return request({
    url: '/admin/ceping93/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping93_save_extra(data){
  return request({
    url: '/admin/ceping93/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping93_detail(data){
  return request({
    url: '/admin/ceping93/detail',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德职业倾向测评
export function ceping94_index(data){
  return request({
    url: '/admin/ceping94/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping94_answer(data){
  return request({
    url: '/admin/ceping94/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping94_reset(data){
  return request({
    url: '/admin/ceping94/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping94_report(data){
  return request({
    url: '/admin/ceping94/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping94_save_extra(data){
  return request({
    url: '/admin/ceping94/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping94_detail(data){
  return request({
    url: '/admin/ceping94/detail',
    method: 'POST',
    data: data || {}
  })
}

// 
// ==========
// ==========2020双十一活动，你是哪种购物星人===========
// 你是哪种购物星人测评
export function ceping79_index(data){
  return request({
    url: '/admin/ceping79/index',
    method: 'POST',
    data: data || {}
  })
}
// 你是哪种购物星人测评提交答案
export function ceping79_answer(data){
  return request({
    url: '/admin/ceping79/answer',
    method: 'POST',
    data: data || {}
  })
}

// 你是哪种购物星人测评重新测试
export function ceping79_reset(data){
  return request({
    url: '/admin/ceping79/reset',
    method: 'POST',
    data: data || {}
  })
}
// 你是哪种购物星人测评报告
export function ceping79_report(data){
  return request({
    url: '/admin/ceping79/report',
    method: 'POST',
    data: data || {}
  })
}
// 你是哪种购物星人测评详情
export function ceping79_detail(data){
  return request({
    url: '/admin/ceping79/detail',
    method: 'POST',
    data: data || {}
  })
}

// 你是哪种购物星人助力接口
export function ceping79_support_user(data){
  return request({
    url: '/admin/ceping79/support_user',
    method: 'POST',
    data: data || {}
  })
}

// 你是哪种购物星人查询助力
export function ceping79_check_support_user(data){
  return request({
    url: '/admin/ceping79/check_support_user',
    method: 'POST',
    data: data || {}
  })
}


/**
 * 
 * 复制ceping73，不需要登陆
 * 
 */
// 霍兰德职业倾向测评
export function sale_ceping73_index(data){
  return request({
    url: '/admin/sale_ceping73/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function sale_ceping73_answer(data){
  return request({
    url: '/admin/sale_ceping73/answer',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德职业倾向测评报告
export function sale_ceping73_report(data){
  return request({
    url: '/admin/sale_ceping73/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function sale_ceping73_save_extra(data){
  return request({
    url: '/admin/sale_ceping73/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function sale_ceping73_detail(data){
  return request({
    url: '/admin/sale_ceping73/detail',
    method: 'POST',
    data: data || {}
  })
}




/**
 *
 *  价值观测评-新版
 * @export
 * @param {*} data
 * @returns
 */
export function ceping46_index(data){
  return request({
    url: '/admin/ceping46/index',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评提交答案
export function ceping46_answer(data){
  return request({
    url: '/admin/ceping46/answer',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评重新测试
export function ceping46_reset(data){
  return request({
    url: '/admin/ceping46/reset',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评报告
export function ceping46_report(data){
  return request({
    url: '/admin/ceping46/report',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评保存兴趣
export function ceping46_save_extra(data){
  return request({
    url: '/admin/ceping46/save_extra',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德职业倾向测评详情
export function ceping46_detail(data){
  return request({
    url: '/admin/ceping46/detail',
    method: 'POST',
    data: data || {}
  })
}


// 霍兰德6岛活动接口-基本信息
export function ceping80_info(data){
  return request({
    url: '/admin/ceping80/info',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德6岛活动接口-分享海报
export function ceping80_poster(data){
  return request({
    url: '/admin/ceping80/poster',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德6岛活动接口-邀请记录
export function ceping80_invite_log(data){
  return request({
    url: '/admin/ceping80/invite_log',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德6岛活动接口-消费记录
export function ceping80_activity_log(data){
  return request({
    url: '/admin/ceping80/activity_log',
    method: 'POST',
    data: data || {}
  })
}
// 霍兰德6岛活动接口-记录消费
export function ceping80_log_activity(data){
  return request({
    url: '/admin/ceping80/log_activity',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德6岛活动接口-助力
export function ceping80_support_user(data){
  return request({
    url: '/admin/ceping80/support_user',
    method: 'POST',
    data: data || {}
  })
}

// 霍兰德6岛活动接口-重置（测试使用）
export function ceping80_reset(data){
  return request({
    url: '/admin/ceping80/reset',
    method: 'POST',
    data: data || {}
  })
}

// 做自己节测评-用户信息
export function ceping81_info(data){
  return request({
    url: '/admin/ceping81/info',
    method: 'POST',
    data: data || {}
  })
}

// 做自己节测评-分享海报
export function ceping81_poster(data){
  return request({
    url: '/admin/ceping81/poster',
    method: 'POST',
    data: data || {}
  })
}

// 做自己节测评-助力
export function ceping81_support_user(data){
  return request({
    url: '/admin/ceping81/support_user',
    method: 'POST',
    data: data || {}
  })
}

// 做自己节测评-排名列表
export function ceping81_rank_list(data){
  return request({
    url: '/admin/ceping81/rank_list',
    method: 'POST',
    data: data || {}
  })
}
// 做自己节测评-重置方便测试
export function ceping81_reset(data){
  return request({
    url: '/admin/ceping81/reset',
    method: 'POST',
    data: data || {}
  })
}

// 做自己节测评-统计
export function ceping81_event(data){
  return request({
    url: '/admin/ceping/event',
    method: 'POST',
    data: data || {}
  })
}

// 测评统计
export function ceping_event(data){
  return request({
    url: '/admin/ceping/event',
    method: 'POST',
    data: data || {}
  })
}


/**
 * 
 * 做自己节裂变
 * 
 */
// 做自己节测评-排名列表
export function ceping81_1_rank_list(data){
  return request({
    url: '/admin/activity/rank_list',
    method: 'POST',
    data: data || {}
  })
}

// 做自己节测评-助力
export function ceping81_1_support_user(data){
  return request({
    url: '/admin/activity/support_user',
    method: 'POST',
    data: data || {}
  })
}


// 提交额外信息
export function ceping58_save_extra(data){
  return request({
    url: '/admin/ceping58/save_extra',
    method: 'POST',
    data: data || {}
  })
}

/**
 * 
 * 一封信测评
 * 
 */

// 提交填写信息
export function ceping82_save_data(data){
  return request({
    url: '/admin/ceping/save_data',
    method: 'POST',
    data: data || {}
  })
}

// 提交额外信息
export function ceping82_save_extra(data){
  return request({
    url: '/admin/ceping82/save_extra',
    method: 'POST',
    data: data || {}
  })
}

// 获取收到信的内容
export function ceping82_get_data(data){
  return request({
    url: '/admin/ceping/get_data',
    method: 'POST',
    data: data || {}
  })
}
// 获取当前用户所有已写的信
export function ceping82_get_data_list(data){
  return request({
    url: '/admin/ceping/get_data_list',
    method: 'POST',
    data: data || {}
  })
}
// 获取当前用户信息
export function ceping82_info(data){
  return request({
    url: '/admin/ceping82/info',
    method: 'POST',
    data: data || {}
  })
}
// 生成海报
export function ceping82_poster(data){
  return request({
    url: '/admin/ceping82/poster',
    method: 'POST',
    data: data || {}
  })
}

// 职业现状测评
export function ceping83_index(data){
  return request({
    url: '/admin/ceping83/index',
    method: 'POST',
    data: data || {}
  })
}
// 职业现状测评提交答案
export function ceping83_answer(data){
  return request({
    url: '/admin/ceping83/answer',
    method: 'POST',
    data: data || {}
  })
}

// 职业现状测评重新测试
export function ceping83_reset(data){
  return request({
    url: '/admin/ceping83/reset',
    method: 'POST',
    data: data || {}
  })
}
// 职业现状测评报告
export function ceping83_report(data){
  return request({
    url: '/admin/ceping83/report',
    method: 'POST',
    data: data || {}
  })
}
// 职业现状测评详情
export function ceping83_detail(data){
  return request({
    url: '/admin/ceping83/detail',
    method: 'POST',
    data: data || {}
  })
}

// 提交螳螂
export function submit_mantis(data){
  return request({
    url: '/admin/ceping/submit_mantis',
    method: 'POST',
    data: data || {}
  })
}

// 职业定向2.0测评
export function ceping95_index(data){
  return request({
    url: '/admin/ceping95/index',
    method: 'POST',
    data: data || {}
  })
}

// 职业定向2.0测评---分段答题
export function ceping95_section(data){
  return request({
    url: '/admin/ceping95/section',
    method: 'POST',
    data: data || {}
  })
}
// 职业定向2.0测评提交答案
export function ceping95_answer(data){
  return request({
    url: '/admin/ceping95/answer',
    method: 'POST',
    data: data || {}
  })
}
// 职业定向2.0测评重新测试
export function ceping95_reset(data){
  return request({
    url: '/admin/ceping95/reset',
    method: 'POST',
    data: data || {}
  })
}
// 职业定向2.0测评报告
export function ceping95_report(data){
  return request({
    url: '/admin/ceping95/report',
    method: 'POST',
    data: data || {}
  })
}


// 价值观测评 原ceping64
export function ceping100_index(data){
  return request({
    url: '/admin/ceping100/index',
    method: 'POST',
    data: data || {}
  })
}
// 价值观测评提交答案
export function ceping100_answer(data){
  return request({
    url: '/admin/ceping100/answer',
    method: 'POST',
    data: data || {}
  })
}
// 价值观测评重新测试
export function ceping100_reset(data){
  return request({
    url: '/admin/ceping100/reset',
    method: 'POST',
    data: data || {}
  })
}
// 价值观测评报告
export function ceping100_report(data){
  return request({
    url: '/admin/ceping100/report',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评 原ceping65
export function ceping101_index(data){
  return request({
    url: '/admin/ceping101/index',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评提交答案
export function ceping101_answer(data){
  return request({
    url: '/admin/ceping101/answer',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评  他评  提交数据 --- 新增+1
export function ceping101_ta_answer(data){
  return request({
    url: '/admin/ceping101/ta_answer',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评  他评  获取数据 --- 新增+1
export function ceping101_ta_index(data){
  return request({
    url: '/admin/ceping101/ta_index',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评重新测试
export function ceping101_reset(data){
  return request({
    url: '/admin/ceping101/reset',
    method: 'POST',
    data: data || {}
  })
}
// 能力热力图测评报告
export function ceping101_report(data){
  return request({
    url: '/admin/ceping101/report',
    method: 'POST',
    data: data || {}
  })
}

// 职业定向2.0测评 原ceping67
export function ceping103_index(data){
  return request({
    url: '/admin/ceping103/index',
    method: 'POST',
    data: data || {}
  })
}

// 职业定向2.0测评---分段答题
export function ceping103_section(data){
  return request({
    url: '/admin/ceping103/section',
    method: 'POST',
    data: data || {}
  })
}
// 职业定向2.0测评提交答案
export function ceping103_answer(data){
  return request({
    url: '/admin/ceping103/answer',
    method: 'POST',
    data: data || {}
  })
}
// 职业定向2.0测评重新测试
export function ceping103_reset(data){
  return request({
    url: '/admin/ceping103/reset',
    method: 'POST',
    data: data || {}
  })
}
// 职业定向2.0测评报告
export function ceping103_report(data){
  return request({
    url: '/admin/ceping103/report',
    method: 'POST',
    data: data || {}
  })
}

// 大学生兴趣测评 原ceping69
export function ceping104_index(data){
  return request({
    url: '/admin/ceping104/index',
    method: 'POST',
    data: data || {}
  })
}
// 大学生兴趣测评提交答案
export function ceping104_answer(data){
  return request({
    url: '/admin/ceping104/answer',
    method: 'POST',
    data: data || {}
  })
}
// 大学生兴趣测评  他评  提交数据 --- 新增+1
export function ceping104_ta_answer(data){
  return request({
    url: '/admin/ceping104/ta_answer',
    method: 'POST',
    data: data || {}
  })
}
// 大学生兴趣测评  他评  获取数据 --- 新增+1
export function ceping104_ta_index(data){
  return request({
    url: '/admin/ceping104/ta_index',
    method: 'POST',
    data: data || {}
  })
}
// 大学生兴趣测评重新测试
export function ceping104_reset(data){
  return request({
    url: '/admin/ceping104/reset',
    method: 'POST',
    data: data || {}
  })
}
// 大学生兴趣测评报告
export function ceping104_report(data){
  return request({
    url: '/admin/ceping104/report',
    method: 'POST',
    data: data || {}
  })
}

// 113
export function ceping113_index(data){
  return request({
    url: '/admin/ceping113/index',
    method: 'POST',
    data: data || {}
  })
}
// 113提交答案
export function ceping113_answer(data){
  return request({
    url: '/admin/ceping113/answer',
    method: 'POST',
    data: data || {}
  })
}

// 113重新测试
export function ceping113_reset(data){
  return request({
    url: '/admin/ceping113/reset',
    method: 'POST',
    data: data || {}
  })
}
// 113报告
export function ceping113_report(data){
  return request({
    url: '/admin/ceping113/report',
    method: 'POST',
    data: data || {}
  })
}
// 113详情
export function ceping113_detail(data){
  return request({
    url: '/admin/ceping113/detail',
    method: 'POST',
    data: data || {}
  })
}

// 114
export function ceping114_index(data){
  return request({
    url: '/admin/ceping114/index',
    method: 'POST',
    data: data || {}
  })
}
// 114提交答案
export function ceping114_answer(data){
  return request({
    url: '/admin/ceping114/answer',
    method: 'POST',
    data: data || {}
  })
}

// 114重新测试
export function ceping114_reset(data){
  return request({
    url: '/admin/ceping114/reset',
    method: 'POST',
    data: data || {}
  })
}
// 114报告
export function ceping114_report(data){
  return request({
    url: '/admin/ceping114/report',
    method: 'POST',
    data: data || {}
  })
}
// 114详情
export function ceping114_detail(data){
  return request({
    url: '/admin/ceping114/detail',
    method: 'POST',
    data: data || {}
  })
}